import React from 'react';
import { connect } from 'react-redux';
import { closeCustomerSpecModal } from 'actions/ui';
import { ModalWindow } from 'ui-core-dashboard';
import { withTranslation } from 'react-i18next';
import { get } from 'lodash';
import Form from './Form';

const mapStateToProps = (state) => ({
    showCustomerSpecModal: state.ui.showCustomerSpecModal,
    customerSpecModalType: state.ui.customerSpecModalType,
    customModalTitle: get(state.ui, 'customerSpecModificationContext.modalTitle'),
});

const mapDispatchToProps = (dispatch) => ({
    closeCustomerSpecModal: () => dispatch(closeCustomerSpecModal()),
});


@withTranslation()
@connect(mapStateToProps, mapDispatchToProps)
class CustomerSpecModal extends React.Component {
    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyPress);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyPress);
    }

    onClose = () => this.props.closeCustomerSpecModal();

    handleKeyPress = (e) => {
        if (e.keyCode === 27) {
            this.onClose();
        }
    };

    render() {
        const { showCustomerSpecModal, t, customModalTitle } = this.props;
        return (
            showCustomerSpecModal && <ModalWindow className="ordering-component-ui-core-wrapper" onClose={this.onClose}>
                <header className="modal-window-header">
                    <div className="modal-window-title">{customModalTitle || t(`newEntityButton.${this.props.customerSpecModalType}`)}</div>
                </header>
                <Form t={t} closeModal={this.onClose}/>
            </ModalWindow>
        );
    }
}

export default CustomerSpecModal;
